/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import {
  Group,
  Title,
  Image,
  Modal,
  Space,
  Text,
  Stack,
  Box,
  Center,
  Button,
  Select,
} from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { ChevronDown } from 'tabler-icons-react';
import Logo from '../../image/hyperthings-logo.png';
import { sendRequest } from '../../services/services';
import CashierAmount from '../PaymentStatus/CashierPrint';

const Profile = () => {
  const navigate = useNavigate();

  const [opened, setOpened] = useState(false);

  const [profileData, setProfileData] = useState({});
  const [totalAmountData, setTotalAmountData] = useState();

  const fetchProfile = () => {
    sendRequest(`cashier/profile`, 'get')
      .then((res) => {
        setProfileData(res?.data || []);
      })

      .catch((err) => {
        if (err?.response?.data?.code) {
          // eslint-disable-next-line no-console
          console.log('err', err?.response?.data?.code);
          if (err?.response?.data?.code === 43) {
            navigate('/');
            localStorage.setItem('token', '');
            localStorage.setItem('userData', '');
          }
        }
      });
  };
  console.log('asd', profileData?.msg);

  const fetchTotalAmount = () => {
    sendRequest(`cashier/collect-payment`, 'get').then((res) => {
      setTotalAmountData(res?.data || []);
    });
  };
  useEffect(() => {
    fetchProfile();
    fetchTotalAmount();
    setTimeout(fetchProfile(), 2000);
    setTimeout(fetchTotalAmount(), 2000);
  }, []);

  const status = `?is_online=${true}`;
  const shiftUpdate = () => {
    sendRequest(`/cashier/change-status${status}`, 'post')
      .then(({ msg }) => {
        if (msg === 'Profile online status updated successfully!') {
          // setOpened(false);
          fetchProfile();
          // setCashData(data);
          fetchTotalAmount();
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          // eslint-disable-next-line no-console
          console.log('err', err?.response?.data?.code);
        }
      });
  };

  return (
    <Box>
      <Stack>
        <Center>
          <Image src={Logo} width={130} />
        </Center>
        <Title order={5}>Welcome : {profileData?.name}</Title>
        <Title order={5}>Date: {dayjs(profileData?.last_login_at).format('hh:mma DD/MM/YY')}</Title>
        <Group>
          <Title order={5}>Status:</Title>
          <Select
            sx={{ width: '100px' }}
            data={[
              { value: '1', label: 'Online' },
              { value: '2', label: 'Offline' },
            ]}
            rightSection={<ChevronDown size={14} />}
            onChange={() => shiftUpdate()}
            value={profileData?.is_online === true ? '1' : '2'}
            disabled
          />
        </Group>
      </Stack>
      <Space h="sm" />
      <Stack>
        <Title order={6}>Amount collected in cash</Title>
        <Center>
          {profileData?.is_online === true && profileData?.online_from ? (
            <Title order={2}>{Number(totalAmountData?.cash).toFixed(2)} SAR</Title>
          ) : (
            <Title order={2}>{0.0} SAR</Title>
          )}
        </Center>
        <Title order={6}>Amount collected by card</Title>
        <Center>
          {profileData?.is_online === true && profileData?.online_from ? (
            <Title order={2}>{Number(totalAmountData?.card).toFixed(2)} SAR</Title>
          ) : (
            <Title order={2}>{0.0} SAR</Title>
          )}
        </Center>
      </Stack>
      <Space h="xs" />
      <Center>
        {profileData?.is_online === true && profileData?.online_from ? (
          <Button
            style={{ backgroundColor: '#D9D9D9', color: 'black', width: 180 }}
            width="100%"
            onClick={() => setOpened(true)}
            // onClick={() => cashierPrint()}
          >
            Shift End
          </Button>
        ) : (
          <Button
            style={{ backgroundColor: '#D9D9D9', color: 'black', width: 180 }}
            width="100%"
            onClick={() => shiftUpdate()}
            // onClick={() => cashierPrint()}
          >
            Shift Start
          </Button>
        )}
      </Center>

      <Modal
        opened={opened}
        centered
        onClose={() => setOpened(false)}
        title={
          <Text p="xl" className="no-printme">
            {profileData?.is_online === true
              ? 'You want to end the shift'
              : 'You want to start the shift'}
          </Text>
        }
      >
        <Center>
          <Group>
            <CashierAmount profile={profileData} amountTotal={totalAmountData} />
          </Group>
        </Center>
      </Modal>
    </Box>
  );
};

export default Profile;
